module.exports = __webpack_public_path__ + "static/Jain-0bd31cebd37840dbd63c7fcf02a09e7a.png";